<template>
    <div v-if="approvalsHistory && approvalsHistory.length > 0">
        <h2 id="approvals-history" class="atmo-hash-jump-point font-weight-bold">История согласований</h2>

        <b-table-simple class="table-atmo" small>
            <thead>
            <tr>
                <th class="py-1">Представитель заказчика</th>
                <th class="py-1">Представитель ГРБС / МО</th>
                <th class="py-1">Комментарий</th>
                <th class="py-1">Дата запроса</th>
                <th class="py-1">Дата ответа</th>
                <th class="py-1">Статус</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="approval in approvalsHistory" :key="approval.id">
                <td class="align-text-top py-1">
                    <template v-if="approval.sent_by.name"><b>ФИО: </b>{{ approval.sent_by.name }}<br></template>
                    <template v-if="approval.sent_by.phone"><b>Телефон: </b>{{ $parsePhone(approval.sent_by.phone) }}<br></template>
                    <template v-if="approval.sent_by.email"><b>Email: </b>{{ approval.sent_by.email }}<br></template>
                </td>
                <td class="align-text-top py-1">
                    <template v-if="approval.replied_by.name"><b>ФИО: </b>{{ approval.replied_by.name }}<br></template>
                    <template v-if="approval.replied_by.phone"><b>Телефон: </b>{{ $parsePhone(approval.replied_by.phone) }}<br></template>
                    <template v-if="approval.replied_by.email"><b>Email: </b>{{ approval.replied_by.email }}<br></template>
                </td>
                <td class="align-text-top py-1">
                    <template v-if="approval.comment"><b>Комментарий: </b>{{ approval.comment }}<br></template>
                    <template v-if="approval.attachment"><b>Приложенный документ: </b><a class="green-link" :href="$getAttachmentDownloadLink(approval.attachment.id)">{{ approval.attachment.name }}</a></template>
                </td>
                <td class="align-text-top py-1">
                    {{ approval.sent_at ? $formatDateTime(approval.sent_at) : '&mdash;' }}
                </td>
                <td class="align-text-top py-1">
                    {{ approval.replied_at ? $formatDateTime(approval.replied_at) : '&mdash;' }}
                </td>
                <td class="align-text-top py-1">
                    <b-badge :variant="statusBadgeVariant(approval.status.id)" pill>{{ approval.status.title }}</b-badge>
                </td>
            </tr>
            </tbody>
        </b-table-simple>
    </div>

</template>

<script>
export default {
    name: 'fl44-approvals-history-block',
    props: {
        approvalsHistory: {
            type: Array,
        }
    },
    methods: {
        statusBadgeVariant(status) {
            switch (status) {
                case 'new':
                    return 'secondary';
                case 'declined':
                    return 'danger';
                case 'approved':
                    return 'success';
            }
        },
    }
};
</script>
